export const MODULE_NAME = 'estimation';
export const ACCESS_NAME = 'Estimations';
